(function installChameleonPulse(global) {
  'use strict';

  const allowed = new Set([
    'chameleon.ckb.search',
    'chameleon.ckb.search_result_clicked',
    'chameleon.ckb.article_opened',
    'chameleon.ckb.ask_submitted',
    'chameleon.ckb.answer_shown',
    'chameleon.system_builder.started',
    'chameleon.system_builder.step',
    'chameleon.system_builder.completed',
    'chameleon.system_builder.missing_part_clicked',
    'chameleon.system_builder.cart_prepared',
    'chameleon.system_builder.cart_added',
    'chameleon.system_builder.cart_blocked',
    'chameleon.product_decision.viewed',
    'chameleon.product_decision.action',
    'chameleon.compatibility.opened',
    'chameleon.product_handbook.clicked',
    'chameleon.pattern.opened',
    'chameleon.document.downloaded',
    'chameleon.campaign.clicked',
    'chameleon.out_of_stock_viewed',
    'chameleon.broken_link_viewed',
    'chameleon.search_no_results',
    'chameleon.video.started',
    'chameleon.video.progress',
    'chameleon.video.completed',
    'chameleon.video.cta_clicked',
    'chameleon.hf_conditions.opened',
    'chameleon.hf_conditions.refreshed',
    'chameleon.hf_conditions.band_selected',
    'chameleon.hf_conditions.source_opened',
    'chameleon.engagement',
    'chameleon.video.engagement',
    'chameleon.cta.clicked',
    'chameleon.experiment.exposed'
  ]);

  const publish = (name, data) => {
    if (!allowed.has(name) || typeof global.Shopify?.analytics?.publish !== 'function') return Promise.resolve(false);
    return Promise.resolve(global.Shopify.analytics.publish(name, data || {})).catch(() => false);
  };

  global.ChameleonPulse = Object.freeze({
    ckbSearch: (searchTerm, resultsCount) => publish('chameleon.ckb.search', { searchTerm, resultsCount, surface: 'ckb' }),
    ckbSearchResultClicked: (searchTerm, resultsCount, articleHandle, articleTitle, articleCategory, articleSection, resultPosition) => publish('chameleon.ckb.search_result_clicked', { searchTerm, resultsCount, articleHandle, articleTitle, articleCategory, articleSection, resultPosition, surface: 'ckb' }),
    ckbArticleOpened: (articleHandle, articleTitle, articleCategory, articleSection) => publish('chameleon.ckb.article_opened', { articleHandle, articleTitle, articleCategory, articleSection, surface: 'ckb' }),
    ckbAskSubmitted: searchTerm => publish('chameleon.ckb.ask_submitted', { searchTerm, surface: 'ckb' }),
    ckbAnswerShown: articleHandle => publish('chameleon.ckb.answer_shown', { articleHandle, surface: 'ckb' }),
    builderStarted: () => publish('chameleon.system_builder.started', { surface: 'system-builder' }),
    builderStep: builderStep => publish('chameleon.system_builder.step', { builderStep, surface: 'system-builder' }),
    builderCompleted: (productId, productTitle) => publish('chameleon.system_builder.completed', { productId, productTitle, surface: 'system-builder' }),
    builderMissingPartClicked: (productId, productTitle) => publish('chameleon.system_builder.missing_part_clicked', { productId, productTitle, surface: 'system-builder' }),
    builderCartPrepared: (productId, productTitle, quantity) => publish('chameleon.system_builder.cart_prepared', { productId, productTitle, quantity, surface: 'system-builder' }),
    builderCartAdded: (productId, productTitle, quantity) => publish('chameleon.system_builder.cart_added', { productId, productTitle, quantity, surface: 'system-builder' }),
    builderCartBlocked: (productId, productTitle, builderStep) => publish('chameleon.system_builder.cart_blocked', { productId, productTitle, builderStep, surface: 'system-builder' }),
    productDecisionViewed: (productId, productTitle, builderStep) => publish('chameleon.product_decision.viewed', { productId, productTitle, builderStep, surface: 'product-decision' }),
    productDecisionAction: (productId, productTitle, builderStep) => publish('chameleon.product_decision.action', { productId, productTitle, builderStep, surface: 'product-decision' }),
    compatibilityOpened: (productId, productTitle) => publish('chameleon.compatibility.opened', { productId, productTitle, surface: 'product-decision' }),
    productHandbookClicked: (productId, productTitle) => publish('chameleon.product_handbook.clicked', { productId, productTitle, surface: 'product-decision' }),
    patternOpened: (productId, productTitle) => publish('chameleon.pattern.opened', { productId, productTitle, surface: 'product-decision' }),
    documentDownloaded: (documentName, documentPath, articleHandle, surface) => publish('chameleon.document.downloaded', { documentName, documentPath, articleHandle, surface }),
    outOfStockViewed: (productId, productTitle, variantId) => publish('chameleon.out_of_stock_viewed', { productId, productTitle, variantId }),
    brokenLinkViewed: httpStatus => publish('chameleon.broken_link_viewed', { httpStatus }),
    searchNoResults: searchTerm => publish('chameleon.search_no_results', { searchTerm, resultsCount: 0 }),
    videoStarted: (videoId, videoTitle, surface) => publish('chameleon.video.started', { videoId, videoTitle, surface }),
    videoProgress: (videoId, videoTitle, surface, percent) => publish('chameleon.video.progress', { videoId, videoTitle, surface, percent }),
    videoCompleted: (videoId, videoTitle, surface) => publish('chameleon.video.completed', { videoId, videoTitle, surface }),
    videoCtaClicked: (videoId, videoTitle, surface) => publish('chameleon.video.cta_clicked', { videoId, videoTitle, surface }),
    hfConditionsOpened: () => publish('chameleon.hf_conditions.opened', { actionName: 'opened', surface: 'ckb-hf-conditions' }),
    hfConditionsRefreshed: () => publish('chameleon.hf_conditions.refreshed', { actionName: 'refreshed', surface: 'ckb-hf-conditions' }),
    hfConditionsBandSelected: (band, mission, condition) => publish('chameleon.hf_conditions.band_selected', { actionName: `${band}m | ${mission} | ${condition}`, surface: 'ckb-hf-conditions' }),
    hfConditionsSourceOpened: source => publish('chameleon.hf_conditions.source_opened', { actionName: source, surface: 'ckb-hf-conditions' }),
    engagement: (engagementSeconds, scrollDepth) => publish('chameleon.engagement', { engagementSeconds, scrollDepth, surface: 'storefront' }),
    videoEngagement: (documentName, videoPercent) => publish('chameleon.video.engagement', { documentName, videoPercent, surface: 'video' }),
    ctaClicked: (actionName, productId, productTitle) => publish('chameleon.cta.clicked', { actionName, productId, productTitle, surface: 'storefront' }),
    experimentExposed: (experimentId, experimentVariant) => publish('chameleon.experiment.exposed', { experimentId, experimentVariant, surface: 'experiment' })
  });

  let activeSince = Date.now();
  let activeMilliseconds = 0;
  let maximumScroll = 0;
  const sentScroll = new Set();
  const videoMilestones = new WeakMap();
  const activeSeconds = () => Math.round((activeMilliseconds + (document.visibilityState === 'visible' ? Date.now() - activeSince : 0)) / 1000);
  const scrollDepth = () => {
    const height = Math.max(document.documentElement.scrollHeight - innerHeight, 1);
    maximumScroll = Math.max(maximumScroll, Math.min(100, Math.round((scrollY / height) * 100)));
    return maximumScroll;
  };
  const publishEngagement = force => {
    const depth = scrollDepth();
    const milestone = [90,75,50,25].find(value => depth >= value && !sentScroll.has(value));
    if (!force && !milestone) return;
    if (milestone) sentScroll.add(milestone);
    global.ChameleonPulse.engagement(Math.min(activeSeconds(), 86400), depth);
  };

  global.addEventListener('scroll', () => publishEngagement(false), { passive:true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      activeMilliseconds += Date.now() - activeSince;
      publishEngagement(true);
    } else activeSince = Date.now();
  });
  global.addEventListener('pagehide', () => publishEngagement(true));

  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href], [data-document-download]');
    if (!link) return;
    const rawHref = link.getAttribute('href') || link.dataset.documentDownload || '';
    let url;
    try { url = new URL(rawHref, global.location.href); } catch { return; }
    if (!/\.pdf$/i.test(url.pathname) && !link.hasAttribute('data-document-download')) return;
    const current = new URL(global.location.href);
    const articleHandle = current.searchParams.get('article') || link.dataset.articleHandle || '';
    const surface = link.dataset.surface || (current.pathname.includes('/pages/chameleon-knowledge-base') ? 'ckb' : current.pathname.includes('/products/') ? 'product' : 'site');
    const fallbackName = decodeURIComponent(url.pathname.split('/').pop() || 'Official document').replace(/[-_]+/g, ' ').replace(/\.pdf$/i, '').trim();
    const documentName = link.dataset.documentName || link.textContent.trim() || fallbackName;
    publish('chameleon.document.downloaded', { documentName, documentPath: url.pathname, articleHandle, surface });
  });
  document.addEventListener('click', event => {
    const target = event.target.closest?.('[data-chameleon-pulse-action]');
    if (target) global.ChameleonPulse.ctaClicked(target.dataset.chameleonPulseAction, target.dataset.productId || '', target.dataset.productTitle || '');
  });
  document.addEventListener('click', event => {
    const addButton = event.target.closest?.('form[action*="/cart/add"] button[type="submit"], .product-form__add-btn');
    if (addButton) {
      const productRoot = addButton.closest('[data-product-id], product-single');
      global.ChameleonPulse.ctaClicked('add_to_cart_intent', productRoot?.dataset.productId || '', document.querySelector('h1')?.textContent?.trim() || '');
      return;
    }
    const checkout = event.target.closest?.('[name="checkout"], a[href*="/checkout"]');
    if (checkout) global.ChameleonPulse.ctaClicked('checkout_started', '', '');
    const support = event.target.closest?.('a[href*="/pages/contact"]');
    if (support && location.pathname.includes('/products/')) global.ChameleonPulse.ctaClicked('pre_sale_support_intent', '', document.querySelector('h1')?.textContent?.trim() || '');
  });
  document.addEventListener('timeupdate', event => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement) || !Number.isFinite(video.duration) || video.duration <= 0) return;
    const percentage = Math.min(100, Math.round((video.currentTime / video.duration) * 100));
    const sent = videoMilestones.get(video) || new Set();
    const milestone = [100,90,75,50,25].find(value => percentage >= value && !sent.has(value));
    if (!milestone) return;
    sent.add(milestone);
    videoMilestones.set(video, sent);
    global.ChameleonPulse.videoEngagement(video.dataset.pulseTitle || video.getAttribute('aria-label') || 'Storefront video', milestone);
  }, true);
  document.querySelectorAll('[data-chameleon-experiment][data-chameleon-variant]').forEach(element =>
    global.ChameleonPulse.experimentExposed(element.dataset.chameleonExperiment, element.dataset.chameleonVariant));
  try {
    const referrer = new URL(document.referrer);
    if (location.pathname.includes('/products/') && referrer.pathname.includes('/pages/chameleon-knowledge-base')) {
      global.ChameleonPulse.ctaClicked('tool_to_product', '', document.querySelector('h1')?.textContent?.trim() || '');
    }
  } catch {}
  global.dispatchEvent(new CustomEvent('chameleon:pulse-ready'));
}(window));
